import {NgModule} from '@angular/core';
import {CiBasicConfigPage} from "./page/overview/ci-basic-config/ci-basic-config.page";
import {
    CiSearchFlexibleInsuranceComponent
} from "./search/ci-search-flexible-insurance/ci-search-flexible-insurance.component";
import {
    CiContractInsurableObjectComponent
} from "./component/protected-components/ci-contract-insurable-object-component/ci-contract-insurable-object.component";
import {
    CiContractPersonComponent
} from "./component/protected-components/ci-contract-person-component/ci-contract-person.component";
import {
    CiInsurableObjectObjectComponent
} from "./component/object-components/ci-insurable-object-object-component/ci-insurable-object-object.component";
import {
    CiCustomerInsurableObjectsComponent
} from "./component/protected-components/ci-customer-insurable-objects-component/ci-customer-insurable-objects.component";
import {
    CiCustomerInsurableObjectCreateComponent
} from "./component/protected-components/ci-customer-insurable-object-create-component/ci-customer-insurable-object-create.component";
import {
    CiCustomerExternalObjectsComponent
} from "./component/protected-components/ci-customer-external-objects/ci-customer-external-objects.component";
import {
    CiCustomerExternalObjectsSuggestionComponent
} from "./component/protected-components/ci-customer-external-objects/suggestion/ci-customer-external-objects-suggestion.component";
import {
    CiCustomerInsurableObjectsTestPage
} from "./page/test/ci-customer-insurable-objects-test/ci-customer-insurable-objects-test.page";
import {
    CiCustomerCreateWizardComponent
} from "./component/protected-components/ci-customer-create-wizard/ci-customer-create-wizard.component";
import {
    CiCustomerCreateWizardDialogComponent
} from "./component/protected-components/ci-customer-create-wizard-dialog/ci-customer-create-wizard-dialog.component";
import {
    MvsObjectDetailExpandComponent
} from "./component/shared-components/mvs-object-detail-expand/mvs-object-detail-expand.component";
import {
    CiCustomerCreateWizardTestPage
} from "./page/test/ci-customer-create-wizard-test/ci-customer-create-wizard-test.page";
import {
    CiCustomerExternalObjectsTestPage
} from "./page/test/ci-customer-external-objects-test/ci-customer-external-objects-test.page";
// Vorvertrags-Abgleich: the wrapper, its two children and the routed developer test page.
import {
    CiContractFormerContractsComponent
} from "./component/protected-components/ci-contract-former-contracts/ci-contract-former-contracts.component";
import {
    CiContractFormerContractSuggestionComponent
} from "./component/protected-components/ci-contract-former-contracts/suggestion/ci-contract-former-contract-suggestion.component";
import {
    CiContractFormerContractResolveComponent
} from "./component/protected-components/ci-contract-former-contracts/resolve/ci-contract-former-contract-resolve.component";
import {
    CiContractFormerContractsTestPage
} from "./page/test/ci-contract-former-contracts-test/ci-contract-former-contracts-test.page";
// [TM-1000001988 overnight C] — the rebuilt BODY of arm 3, „Vorgangsabgleich fehlgeschlagen": what
// failed and the four acts. See the declarations entry.
import {
    CiCaseAlignmentFailureComponent
} from "./component/protected-components/ci-case-alignment-failure/ci-case-alignment-failure.component";
// (kein Ticket — ci header decision gate, Haris 2026-10-01) — the Datenabgleich decision matrix of the
// four header fields, mounted by arm 3's body directly below the findings stack (no ticket — findings
// above the decision matrix, Haris 2026-10-12; until then between the headline and the stack).
import {
    CiAlignmentDecisionMatrixComponent
} from "./component/protected-components/ci-alignment-decision-matrix/ci-alignment-decision-matrix.component";
// (kein Ticket — ci Vorvertrag beenden, batch 2) — the Vorvertrag card of the status-3 arm, the in-page
// predecessor guard of the advance, and their developer test page.
import {
    CiFormerContractEndListComponent
} from "./component/protected-components/ci-former-contract-end-list/ci-former-contract-end-list.component";
import {
    CiFormerContractAdvanceGuardComponent
} from "./component/protected-components/ci-former-contract-advance-guard/ci-former-contract-advance-guard.component";
// TM-1000002016: the end-date choice of the former contract, mounted by arm 3's body below the start-day banner.
import {
    CiFormerContractDateChoiceComponent
} from "./component/protected-components/ci-former-contract-date-choice/ci-former-contract-date-choice.component";
import {
    CiFormerContractEndListTestPage
} from "./page/test/ci-former-contract-end-list-test/ci-former-contract-end-list-test.page";
// [TM-1000001988 overnight B] — the rebuilt BODY of arm 5, „Personen-/Objektzuordnung manuell":
// the delivered rows printed on top, Marko's two contract lists below. See the declarations entry.
import {
    CiPostCheckManualComponent
} from "./component/protected-components/ci-post-check-manual/ci-post-check-manual.component";
// [TM-1000001988, Haris 5 Sept 22:08] — <ci-sync-finding-stack>, the findings of one pipeline row as
// ONE compact stack instead of the cards each arm used to draw for itself.
import {
    CiSyncFindingStackComponent
} from "./component/protected-components/ci-sync-finding-stack/ci-sync-finding-stack.component";
// [TM-1000001988 overnight H] — the BODY of arm 5 after the pipeline split of 2026-09-05: step 4
// creates the RELATIONS, arm 5 („Beziehungen") handles what could not be created. It replaces
// <ci-post-check-manual> at status 5; that body is untouched because arm 3 embeds it. See the
// declarations entry.
import {
    CiRelationsManualComponent
} from "./component/protected-components/ci-relations-manual/ci-relations-manual.component";
// [TM-1000001988 overnight H] — „Lieferung (GDV)" as a READ-ONLY print, the two delivered card blocks
// arm 5 shows above the customer-side lists. See the declarations entry.
import {
    CiDeliveredCardsComponent
} from "./component/protected-components/ci-delivered-cards/ci-delivered-cards.component";
// [TM-1000001988 overnight 47] — „Bestand ↔ Lieferung", the already-matched delivered rows as
// read-only pairs. See the declarations entry.
import {
    CiDeliveredMatchPairsComponent
} from "./component/protected-components/ci-delivered-match-pairs/ci-delivered-match-pairs.component";
// [TM-1000001988 overnight B] — routed developer test page of that body. See the declarations entry.
import {
    CiPostCheckManualTestPage
} from "./page/test/ci-post-check-manual-test/ci-post-check-manual-test.page";
// [TM-1000001988 overnight C] — routed developer test page of the rebuilt arm-3 body. See the
// declarations entry.
import {
    CiCaseAlignmentFailureTestPage
} from "./page/test/ci-case-alignment-failure-test/ci-case-alignment-failure-test.page";
// [TM-1000001988] — routed developer test page for ALL delivered (GDV) data of one contract. See the
// declarations entry.
import {
    CiExternalDataTestPage
} from "./page/test/ci-external-data-test/ci-external-data-test.page";
// TM-1000001985: post-processing workbenches (Kundenzuordnung / Personen).
import {CiConvertPage} from "./page/dashboard/ci-convert/ci-convert.page";
import {
    CiConvertCustomerComponent
} from "./page/dashboard/ci-convert/components/ci-convert-customer/ci-convert-customer.component";
import {
    CiConvertCustomerDetailPanelComponent
} from "./page/dashboard/ci-convert/components/ci-convert-customer-detail-panel/ci-convert-customer-detail-panel.component";
// TM-1000001988 — the shared „VSNR (gelieferter Name)" review head, rendered by BOTH benches.
import {
    CiContractReviewHeadComponent
} from "./component/ci-contract-review-head/ci-contract-review-head.component";
import {
    CiCustomerSuggestionCardComponent
} from "./page/dashboard/ci-convert/components/ci-customer-suggestion-card/ci-customer-suggestion-card.component";
// TM-1000001985 §2 — the SHARED assignment picker both ci/convert steps project into.
import {
    CiAssignmentPanelComponent
} from "./page/dashboard/ci-convert/components/ci-assignment-panel/ci-assignment-panel.component";
// TM-1000001985 Phase 2: the Personenzuordnung workbench (host, conflict panel, suggestion card).
import {
    CiConvertPersonComponent
} from "./page/dashboard/ci-convert/components/ci-convert-person/ci-convert-person.component";
import {
    CiConvertPersonDetailPanelComponent
} from "./page/dashboard/ci-convert/components/ci-convert-person-detail-panel/ci-convert-person-detail-panel.component";
import {
    CiPersonSuggestionCardComponent
} from "./page/dashboard/ci-convert/components/ci-person-suggestion-card/ci-person-suggestion-card.component";
// The Vorgang region of the Kundenzuordnung's BOOKED state — projected into <ci-assignment-panel>
// as [decidedTemplate], where the tab strip used to stand.
import {
    CiCustomerCaseSelectionComponent
} from "./page/dashboard/ci-convert/components/ci-customer-case-selection/ci-customer-case-selection.component";
// TM-1000001988 — the „Verarbeitungsstatus" section: the post-import pipeline's human worklist.
import {
    CiContractSyncWorklistComponent
} from "./page/dashboard/ci-convert/components/ci-contract-sync-worklist/ci-contract-sync-worklist.component";
// TM-1000001988 WP-11 — the status-branching RIGHT pane of that worklist.
import {
    CiContractSyncStatusObjectComponent
} from "./component/object-components/ci-contract-sync-status-object-component/ci-contract-sync-status-object.component";
// The Kundenanlage page of the `cr/create` route. It LIVES under cr/ and its route stays in
// cr.route.ts — only its DECLARATION belongs here, because its create surface is
// <ci-customer-create-wizard>. See the declarations entry below.
import {CrCustomerCreatePage} from "../cr/page/object/cr-customer-create/cr-customer-create.page";
import {
    CrCustomerCreateConsultantPage
} from "../cr/page/consultant-page/cr-customer-create-consultant-page/cr-customer-create-consultant.page";
// THE THREE CONTRACT SUB-OBJECT LISTS and their developer test pages.
//
// ⚠ NAMING TRAP, read before importing: CiContractInsurableObjectComponent (singular, selector
// `ci-insurable-object`) is the DETAIL component of ONE ci.ContractInsurableObject row and is
// imported a few lines above this block. CiContractInsurableObjectsComponent (PLURAL, selector
// `ci-contract-insurable-objects`) is the LIST of all such rows of one contract. The two class
// names differ by a single letter, both are declared by this module, and confusing them compiles
// without a word of complaint - the wrong one simply renders nothing recognisable.
import {
    CiContractPersonsComponent
} from "./component/protected-components/ci-contract-persons-component/ci-contract-persons.component";
import {
    CiContractInsurableObjectsComponent
} from "./component/protected-components/ci-contract-insurable-objects-component/ci-contract-insurable-objects.component";
import {
    CiContractPaymentAccountsComponent
} from "./component/protected-components/ci-contract-payment-accounts-component/ci-contract-payment-accounts.component";
import {
    CiContractAgentsComponent
} from "./component/protected-components/ci-contract-agents-component/ci-contract-agents.component";
import {
    CiCollectionAgentBillingCheckComponent
} from "./component/protected-components/ci-collection-agent-billing-check/ci-collection-agent-billing-check.component";
import {
    CiContractPersonsTestPage
} from "./page/test/ci-contract-persons-test/ci-contract-persons-test.page";
import {
    CiContractInsurableObjectsTestPage
} from "./page/test/ci-contract-insurable-objects-test/ci-contract-insurable-objects-test.page";
import {
    CiContractPaymentAccountsTestPage
} from "./page/test/ci-contract-payment-accounts-test/ci-contract-payment-accounts-test.page";
import {
    CiContractAgentsTestPage
} from "./page/test/ci-contract-agents-test/ci-contract-agents-test.page";
import {
    CiCollectionAgentBillingCheckTestPage
} from "./page/test/ci-collection-agent-billing-check-test/ci-collection-agent-billing-check-test.page";
// ⚠ SECOND NAMING TRAP, same family as the one above. CiContractFormerContractsTestPage (imported
// elsewhere, selector `ci-contract-former-contracts`) is the Vorvertrags-ABGLEICH - it reconciles
// DELIVERED former contracts against the stock. CiContractFormersComponent (selector
// `ci-contract-formers`) is the LIST of the former contracts of ONE cm.Contract, and is the only one
// of the two that writes. The names differ by word order alone.
import {
    CiContractFormersComponent
} from "./component/protected-components/ci-contract-formers-component/ci-contract-formers.component";
import {
    CiContractFormersTestPage
} from "./page/test/ci-contract-formers-test/ci-contract-formers-test.page";
// THE FIFTH LIST OF THE FAMILY - <ci-contract-prices>, the cm.ContractPrice rows of ONE cm.Contract.
//
// ⚠ IT IS THE ONLY ONE THAT IS READ ONLY BY CONSTRUCTION rather than by configuration, and the two
// reasons are written out in the component header: a price is period-chained, so it is authored by
// the cm price wizards which close the predecessor themselves, and a second
// <mvs-crud-object [objectType]="'cm.ContractPrice'"> host would widen the recursion surface that
// cm/service/api/contract-price.service.ts:6-19 exists to keep narrow. Its `editMode` type therefore
// EXCLUDES 'inline' - a caller that asks for it gets a compile error, not a missing feature.
import {
    CiContractPricesComponent
} from "./component/protected-components/ci-contract-prices-component/ci-contract-prices.component";
import {
    CiContractPricesTestPage
} from "./page/test/ci-contract-prices-test/ci-contract-prices-test.page";
import {CI_ENTITY_PROVIDER} from "./ci.entity-provider";
import {CoreModule} from "../../core/core.module";
import {PmModule} from "../pm/pm.module";
import {CrModule} from "../cr/cr.module";
// TM-1000002050: the cm wizard <cm-policyholder-change-wizard> is rendered by the slot host below — see the imports
// entry for the cycle check.
import {CmModule} from "../cm/cm.module";
// TM-1000001988 — see the imports entry for the cycle check that was actually performed.
import {CI_TEST_PROVIDERS} from "./test/ci-test-definition";
import {IconField} from "primeng/iconfield";
import {InputIcon} from "primeng/inputicon";
import {RadioButtonModule} from "primeng/radiobutton";
import {TagModule} from "primeng/tag";
import {SkeletonModule} from "primeng/skeleton";
// [TM-1000001988 overnight A] — the two TAKE-OVER panels. See the declarations and exports entries.
import {
    CiDeliveredPersonTakeoverComponent
} from "./component/protected-components/ci-delivered-person-takeover/ci-delivered-person-takeover.component";
import {
    CiDeliveredObjectTakeoverComponent
} from "./component/protected-components/ci-delivered-object-takeover/ci-delivered-object-takeover.component";
// <ci-contract-type-tree> — the ci-owned Kategorie -> Sparte -> Vertragstyp selection tree, left pane
// of the ci developer test page. See the declarations entry.
import {
    CiContractTypeTreeComponent
} from "./component/protected-components/ci-contract-type-tree/ci-contract-type-tree.component";
// The routed developer test page built on top of that tree — the ci Vertragstyp-Konfiguration. See
// the declarations entry.
import {
    CiContractTypeConfigTestPage
} from "./page/test/ci-contract-type-config-test/ci-contract-type-config-test.page";
// The two REUSABLE contract-type pickers — versicherbare Objekte and Personen, narrowed by what one
// cm.ContractType permits and demands, WITHOUT a contract. See the declarations entries.
import {
    CiContractTypeInsurableObjectsComponent
} from "./component/protected-components/ci-contract-type-insurable-objects-component/ci-contract-type-insurable-objects.component";
import {
    CiContractTypePersonsComponent
} from "./component/protected-components/ci-contract-type-persons-component/ci-contract-type-persons.component";
// The two routed developer test pages of those two pickers — one page per component, each one a
// control panel plus the component plus an event log. They are DRIVER pages: unlike
// CiContractTypeConfigTestPage above, which lays the /ci/contractTypeConfig answer out in full, these
// two exist to USE the picker (Objekte bzw. Personen sehen, auswählen und beim Kunden anlegen) and
// therefore carry no configuration panels at all. See the declarations entries.
import {
    CiContractTypeInsurableObjectsTestPage
} from "./page/test/ci-contract-type-insurable-objects-test/ci-contract-type-insurable-objects-test.page";
import {
    CiContractTypePersonsTestPage
} from "./page/test/ci-contract-type-persons-test/ci-contract-type-persons-test.page";
// TM-1000002050: the slot host of the „VN-Wechsel“ wizard. See the declarations and exports entries.
import {
    CiContractPolicyholderChangeHostComponent
} from "./component/object-components/ci-contract-policyholder-change-host/ci-contract-policyholder-change-host.component";

@NgModule({
    declarations: [
        CiBasicConfigPage,
        CiSearchFlexibleInsuranceComponent,
        CiContractInsurableObjectComponent,
        CiContractPersonComponent,
        CiInsurableObjectObjectComponent,
        CiCustomerInsurableObjectsComponent,
        CiCustomerInsurableObjectCreateComponent,
        // The external-object reconciliation: the WRAPPER around <ci-customer-insurable-objects>
        // that matches externally delivered objects against the customer's own, plus the single
        // delivered-object CARD it renders per delivery row.
        //
        // The wrapper is exported below - it is a protected component a document/import strand
        // outside ci legitimately embeds. The card is DECLARED ONLY and deliberately NOT exported,
        // the same rule CiConvertCustomerDetailPanelComponent and CiCustomerSuggestionCardComponent
        // follow: it is reached exclusively through its own host, it holds no state of its own, and
        // exporting it would invite a second caller with a different idea of what a verdict means.
        CiCustomerExternalObjectsComponent,
        CiCustomerExternalObjectsSuggestionComponent,
        // The customer-create wizard of the Vertragsnachbearbeitung, and its modal packaging.
        // Declared here AND exported below: they are protected components, so the convert workbench
        // of this module and any other feature-crm module that gains the „Neuen Kunden anlegen"
        // entry can host either of them.
        CiCustomerCreateWizardComponent,
        CiCustomerCreateWizardDialogComponent,
        // The expandable object detail - compact primary attributes plus a chevron that opens the
        // object's own data widget. It carries NO domain knowledge and imports nothing outside
        // core/shared, so it is declared here only because ci is the module that first needed it;
        // it is a candidate for features/core/shared/object/ as soon as a second module wants it.
        // Exported below for exactly that reason - a promotable component that only this module may
        // render would be promotable in name only.
        MvsObjectDetailExpandComponent,
        // Routed developer test page - declared only, never embedded elsewhere.
        CiCustomerInsurableObjectsTestPage,
        // Routed developer test page - declared only, never embedded elsewhere.
        CiCustomerCreateWizardTestPage,
        // Routed developer test page - declared only, never embedded elsewhere. It drives
        // <ci-customer-external-objects> from a hand-written JSON delivery, which is what makes the
        // reconciliation exercisable while real ci.ContractExtObject data is out of reach.
        CiCustomerExternalObjectsTestPage,
        // Vorvertrags-Abgleich (KONTRAKT.md Teil 3): the wrapper is declared AND exported below - a
        // screen that holds a Vorvertrags-Lieferung for one Ankervertrag (e.g. a document or GDV
        // import strand) may live outside this module and has to be able to render it. Its two
        // children stay declaration-only, the same rule <ci-customer-external-objects> follows for
        // its own card: each is reached exclusively through the wrapper, holds no state of its own,
        // and exporting it would invite a second caller with a different idea of what a decision means.
        CiContractFormerContractsComponent,
        CiContractFormerContractSuggestionComponent,
        CiContractFormerContractResolveComponent,
        // Routed developer test page - declared only, never embedded elsewhere. Decision E7 keeps
        // this order off the backend, so this page is the only way the reconciliation is exercised:
        // it feeds the delivery and the stock by hand and never writes (decision E4.3).
        CiContractFormerContractsTestPage,
        // [TM-1000001988 overnight C] — <ci-case-alignment-failure>, the rebuilt BODY of arm 3.
        //
        // Marko 01:01:39: „you are saying, please book the case … Something could, can badly fail. And
        // then you need to display basically, blah, blah, blah, failed, right?" So the body is the
        // findings of the last run plus four acts — no Buchungsmatrix, no per-area fix drawers, no
        // „Nicht relevant" and no Vorgangsdaten: a matrix is a MAP of Vorgang against Vertrag, and
        // mapping was declined for the manual screens (01:16:44).
        //
        // Declared AND exported. The one host that mounts it, <ci-contract-sync-status-object>, lives
        // in this module — but the developer test page hands it a simulated delta-mode outcome through
        // the same inputs, so the component is deliberately host-agnostic and the export costs nothing.
        CiCaseAlignmentFailureComponent,
        // (kein Ticket — ci header decision gate) — the decision matrix inside arm 3's body.
        CiAlignmentDecisionMatrixComponent,
        // (kein Ticket — batch 2) — the Vorvertrag card, the advance guard dialog and their test page.
        CiFormerContractEndListComponent,
        CiFormerContractAdvanceGuardComponent,
        CiFormerContractEndListTestPage,
        // TM-1000002016: the end-date choice of the former contract inside arm 3's body.
        CiFormerContractDateChoiceComponent,
        // [TM-1000001988, Haris 5 Sept 22:08] — <ci-sync-finding-stack>, the SHARED findings
        // rendering. Declared here because every consumer is here (arm 3's body, the arm-7 pane of
        // <ci-contract-sync-status-object>), and exported for the same reason
        // <ci-post-check-manual> is: it carries no host context — a contractId, or a relayed
        // findings array, and it emits what it found.
        CiSyncFindingStackComponent,
        // [TM-1000001988 overnight B] — <ci-post-check-manual>, the rebuilt body of arm 5.
        //
        // Marko 01:23:18: „you show up top the data that you have, you show in the bottom the data
        // that's in the contract with the option to change it". The component prints the delivered
        // persons and objects and then embeds HIS <ci-contract-persons> / <ci-contract-insurable-objects>
        // below each block — which is why it is declared in THIS module: both of those live here too
        // (see the entries further down), so the composition needs no export and no new module edge.
        //
        // Declared AND exported: the host arm <ci-contract-sync-status-object> is in this module, but
        // the export keeps the body reachable the same way its arm-3 sibling family is, and costs
        // nothing.
        CiPostCheckManualComponent,
        // [TM-1000001988 overnight H] — <ci-relations-manual>, the body of arm 5 after the split of
        // 2026-09-05 („step 4 creates relations, arm 5 handles what could not be created"). It is the
        // component the host mounts at PERSON_OBJECT_ASSIGNMENT_MANUAL now.
        //
        // It composes THREE elements and declares none of their behaviour: <ci-delivered-cards>
        // (below, same module), Marko's <cr-customer-persons> (CrModule declares and EXPORTS it —
        // cr.module.ts:779 — and CiModule already imports CrModule, so no new module edge) and
        // <ci-customer-insurable-objects> (this module). The CUSTOMER-side lists, deliberately: a
        // Person↔Person relation and a Kunde↔Objekt link cannot be expressed by the contract-scoped
        // ones. <cr-person-matrix> is NOT mounted — it is an attribute grid, not a relation view.
        //
        // Declared AND exported, for the same reason its two arm siblings are: the host arm and the
        // developer test page reach it by the same element name, and it takes everything it needs as
        // @Inputs and emits every act, so it carries no hidden host context.
        CiRelationsManualComponent,
        // [TM-1000001988 overnight H] — <ci-delivered-cards>, „Lieferung (GDV)" as a READ-ONLY print.
        //
        // The two delivered card blocks arm 5 shows above the customer-side lists, built from the
        // shared builders in `logic/delivery/`. <ci-post-check-manual> keeps its own inline copy of
        // those two blocks on purpose: arm 3 embeds that body and arm 3 is frozen for this change, so
        // swapping it onto this element is a later, separate step.
        CiDeliveredCardsComponent,
        // [TM-1000001988 overnight 47] — <ci-delivered-match-pairs>, the rows the last run has ALREADY
        // accounted for, printed as „Bestand — am Vertrag" ↔ „Lieferung (GDV) — Extern" pairs with the
        // BLUE „zugeordnet" chip. Read-only and act-free on purpose: the open rows keep the cards and
        // keep „Vergleichen" / „Anlegen und übernehmen", and a settled row may no longer offer them
        // (Haris, 6 Sept 04:59, issue 17).
        CiDeliveredMatchPairsComponent,
        // [TM-1000001988 overnight B] — routed developer test page of that body, reachable by URL
        // only. Declared only, never embedded elsewhere. Marko's harness shape (00:29:01): control
        // panel on the left, the live component on the right, every @Output in a timestamped log.
        CiPostCheckManualTestPage,
        // [TM-1000001988 overnight C] — routed developer test page of <ci-case-alignment-failure>,
        // reachable by URL only. Declared only, never embedded elsewhere. Marko's harness shape
        // (00:29:01): control panel on the left, the live component on the right, every @Output in a
        // timestamped log. Its Simulationsmodus mints the seven delta-mode outcomes locally and reaches
        // NOTHING; its Echt-Modus resolves a real contract the way the workbench host does.
        CiCaseAlignmentFailureTestPage,
        // [TM-1000001988] — routed developer test page for the delivered (GDV) data of one contract,
        // reachable by URL only. Declared only, never embedded elsewhere. Marko's harness shape:
        // control panel on the left, the live display on the right. It READS ONLY: the contract
        // header through the arm-3 folds, the persons and objects through <ci-delivered-cards>.
        CiExternalDataTestPage,
        // TM-1000001985: routed page + its section component. DECLARED only, not exported - the page
        // is reached through the router and the section component only through that page.
        CiConvertPage,
        CiConvertCustomerComponent,
        // The workbench's right-pane detail panel. Declared only — never embedded from outside this
        // module.
        //
        // ⚠ TM-1000001988 — it has TWO hosts now, both inside this module: its own workbench
        // (CiConvertCustomerComponent) and the „Verarbeitungsstatus" arm
        // (CiContractSyncStatusObjectComponent), which mounts it parameterised so both ci/convert
        // screens pick a customer through the same design. Declared-only still holds, and must: the
        // panel is addressed by a ci.ContractExtCustomer row and carries this feature's whole customer
        // vocabulary, so exporting it would let another feature mount a picker it cannot feed.
        CiConvertCustomerDetailPanelComponent,
        // TM-1000001988 — the SHARED review head: the „VSNR: X (gelieferter Name) ⌄" identity line,
        // its chevron and the joined Versicherungsnehmer widget behind it. Extracted out of the panel
        // above so BOTH ci/convert benches render ONE header — the Kundenzuordnung, and every arm of
        // the „Verarbeitungsstatus" pipeline, including the eight read-only ones that mount no bench
        // and therefore had no identity line at all.
        //
        // Declared only, NOT exported, and for the same reason as its two hosts: it is keyed on a
        // cm.Contract and reads ci.ContractExtPerson, i.e. this feature's own vocabulary, and it owns
        // the two header reads outright — a host outside ci could mount it but could not reason about
        // the single-read rule it enforces.
        CiContractReviewHeadComponent,
        // The single suggestion card of the Kundenzuordnung. Declared only — like the panel above it
        // is reached exclusively through CiConvertCustomerDetailPanelComponent and stays internal to
        // this module.
        CiCustomerSuggestionCardComponent,
        // TM-1000001985 §2 — the SHARED assignment picker (tabs + „Suche" + the prepared slot + the
        // confirm footer), extracted out of CiConvertCustomerDetailPanelComponent so both ci/convert
        // steps render one region model. Declared only and deliberately NOT exported: it is reached
        // exclusively through the two detail panels of this module, which project their head, cards
        // and actions into it — exporting it would invite a third caller outside ci with no spec.
        CiAssignmentPanelComponent,
        // TM-1000001985 Phase 2 — the Personenzuordnung section component and its two children.
        // DECLARED only, NOT exported: the section is reached through CiConvertPage, the conflict
        // panel exclusively through CiConvertPersonComponent, and the card exclusively through that
        // panel. All three stay internal to this module.
        CiConvertPersonComponent,
        CiConvertPersonDetailPanelComponent,
        CiPersonSuggestionCardComponent,
        // The Vorgang region of the BOOKED state, rendered inside <ci-assignment-panel> through
        // CiConvertCustomerDetailPanelComponent's #panelDecided. It supersedes the former
        // <ci-case-binding-block>, which sat BELOW the whole panel — i.e. below the button that
        // consumed its answer — and which bound its Vorgang in the same transaction as the customer.
        // Declared only, NOT exported: like the panel it is reached exclusively through that detail
        // panel and stays internal to this module.
        CiCustomerCaseSelectionComponent,
        // TM-1000001988 — the third section of ci/convert (?navItem=sync): the Review Workbench over
        // ci.ContractSyncStatus. DECLARED only, NOT exported: like the two sibling sections it is
        // reached exclusively through CiConvertPage, and exporting it would invite a host outside ci
        // with no spec.
        CiContractSyncWorklistComponent,
        // TM-1000001988 WP-11 — the status-branching RIGHT pane of that worklist: one @switch over
        // ci.ContractSyncStatus.status, two working arms and seven read-only ones.
        //
        // DECLARED only, NOT exported, and that is not an oversight: it is ALSO registered as the
        // `objectComponent` of `ci.ContractSyncStatus` in ci.entity-provider.ts, and the framework
        // resolves that registration through MvsCoreService and instantiates the class dynamically —
        // which needs the DECLARATION, never an export. Exporting it would invite a host outside ci to
        // write <ci-contract-sync-status-object> into its own template, where nothing supplies the
        // review-workbench height chain this pane is written for.
        CiContractSyncStatusObjectComponent,
        // THE `cr/create` PAGE, declared here although it lives under cr/ and is routed from
        // cr.route.ts. Its right half hosts <ci-customer-create-wizard>, which only this module
        // declares; CrModule cannot import CiModule to reach that element because CiModule already
        // imports CrModule and the edge back would close a circular NgModule dependency (BOUND-002).
        // Declared only, NOT exported: nothing embeds <mvs-cr-create-customer-page>, the router is
        // its only entry.
        CrCustomerCreatePage,
        // [CO-APP R3/A] The Co-App variant of that page (shell-consultant `cr/create`) - declared here for
        // the same BOUND-002 reason, also declared only: the consultant router is its only entry.
        CrCustomerCreateConsultantPage,

        // THE THREE CONTRACT SUB-OBJECT LISTS - <ci-contract-persons>,
        // <ci-contract-insurable-objects> and <ci-contract-payment-accounts>. One list of the
        // ci.ContractPerson / ci.ContractInsurableObject / bm.ContractPaymentAccount rows of ONE
        // cm.Contract, each with the two-phase in-place assignment panel behind its „+".
        // <ci-contract-agents> (the cm.ContractAgent rows) is a ditto copy of
        // <ci-contract-payment-accounts> and joins this block: everything below applies to it too.
        //
        // They live in component/protected-components/ and are DECLARED ONLY, deliberately NOT
        // exported: no consumer outside this module embeds them today, and exporting a component
        // nobody embeds is exactly the finding (HIGH-2) this round exists to stop repeating. The day
        // a foreign host does appear, the correct move is the one CrObjectBillingAccountsComponent
        // just made - into component/public-components/ and exported from there, not an export out
        // of protected-components/.
        //
        // ⚠ CiContractInsurableObjectsComponent (plural, the LIST) is NOT
        // CiContractInsurableObjectComponent (singular, the row DETAIL) declared further up. See the
        // import block for why that one letter matters.
        //
        // ⚠ NO crudSuperComponent is registered for ci.ContractPerson, ci.ContractInsurableObject or
        // bm.ContractPaymentAccount, and none may be. Phase B of the assignment panel is a plain
        // <mvs-crud-object>, which resolves its body through MvsCoreService.getCrudSuperComponent()
        // (mvs-crud-object.component.ts:90 -> mvs-core.service.ts:118-128) and falls back to
        // MvsCrudObjectGenericComponent when that key is absent. The generic metadata-driven form IS
        // the intended body. The objectComponent{mode: create} entries these types carry in
        // ci.entity-provider.ts are a DIFFERENT registry (object pages / <mvs-object>) and have no
        // effect here. Registering a crudSuperComponent that itself renders <mvs-crud-object> would
        // make the panel render itself without a termination condition - the danger is spelled out
        // verbatim in cm/service/api/contract-price.service.ts:6-19.
        CiContractPersonsComponent,
        CiContractInsurableObjectsComponent,
        CiContractPaymentAccountsComponent,
        // <ci-contract-agents> - declared only, NOT exported, like the three above.
        // ⚠ NEVER register a crudSuperComponent for cm.ContractAgent in cm.entity-provider.ts: the
        // <mvs-crud-object> inside this component would render itself recursively, with no
        // termination condition - same danger as cm/service/api/contract-price.service.ts:6-19.
        CiContractAgentsComponent,
        // (no ticket — ci agent/billing check 2026-10-08) — <ci-collection-agent-billing-check>, the step-3
        // section „Inkassoart, Vermittler und Abrechnungskonto" mounted by <ci-post-check-manual>. It
        // embeds <ci-contract-agents> and <ci-contract-payment-accounts> (both above). Declared only;
        // p-select, p-button, p-message, p-tag and p-skeleton arrive through CoreModule / TagModule /
        // SkeletonModule below.
        CiCollectionAgentBillingCheckComponent,

        // THE FIFTH LIST - <ci-contract-prices>, the Beiträge of ONE cm.Contract.
        //
        // Declared ONLY, deliberately NOT exported, for the reason the block above gives: no consumer
        // outside this module embeds it today, and exporting a component nobody embeds is the finding
        // (HIGH-2) that block exists to stop repeating. The day a foreign host does appear, the move
        // is into component/public-components/ and an export from there.
        //
        // ⚠ IT LISTS A **cm** ENTITY FROM A **ci** COMPONENT, and that is the established shape of
        // this family rather than a boundary crossing: <ci-contract-payment-accounts> above lists a
        // **bm** entity for exactly the same reason. Module cm is not touched by this at all - the
        // component reads cm.ContractPrice through QL and the object registry, and even the two cm
        // routes of its test page are declared in ci.route.ts (see the block there for the mechanism).
        //
        // ⚠ NO crudSuperComponent may EVER be registered for cm.ContractPrice. This component writes
        // nothing and hosts no <mvs-crud-object>, which is what keeps it out of the recursion that
        // cm/service/api/contract-price.service.ts:6-19 describes: the two price wizard HOSTS each
        // render several <mvs-crud-object [objectType]="'cm.ContractPrice'"> instances themselves, so
        // a registered super component that rendered <mvs-crud-object> would make a wizard render
        // itself with no termination condition. The entry ['cm.ContractPrice', {route:
        // '/cm/contractPrices', service: ContractPriceService}] in cm.entity-provider.ts:85 is a
        // DIFFERENT registry and has no effect here.
        CiContractPricesComponent,

        // THE FOURTH LIST OF THE FAMILY - <ci-contract-formers>, the former contracts of ONE
        // cm.Contract: the MAIN one from cm.Contract.formerContract and the further ones from
        // cm.ContractFormer, in one list as two labelled groups.
        //
        // Declared ONLY, deliberately NOT exported, for exactly the reason the block above gives:
        // no consumer outside this module embeds it today, and exporting a component nobody embeds
        // is the finding (HIGH-2) that block exists to stop repeating. The day a foreign host does
        // appear, the move is into component/public-components/ and an export from there - the move
        // CrObjectBillingAccountsComponent made, and that CrObjectContractsComponent has now made
        // for THIS component's sake: its assignment panel embeds <cr-object-contracts> as phase A.
        //
        // ⚠ IT IS THE FIRST OF THE FAMILY THAT WRITES, and it writes to TWO different targets
        // depending on where a row came from (FD-2): a row from `cm.Contract.formerContract` is
        // changed by a partial update of the ANCHOR cm.Contract, a row from `cm.ContractFormer` by
        // the link row itself. The code decides that from the row's `source`, never from its optics.
        //
        // ⚠ NO crudSuperComponent may EVER be registered for cm.ContractFormer. Phase B of the
        // assignment panel is a plain <mvs-crud-object> whose body resolves through
        // MvsCoreService.getCrudSuperComponent() and falls back to MvsCrudObjectGenericComponent -
        // the generic metadata-driven form IS the intended body. A crudSuperComponent that itself
        // rendered <mvs-crud-object> would make the panel render itself with no termination
        // condition. The entry ['cm.ContractFormer', {route: '/cm/contractFormers'}] in
        // cm.entity-provider.ts is a DIFFERENT registry and has no effect here.
        CiContractFormersComponent,

        // Routed developer test pages for the three lists and <ci-contract-agents> - declared only,
        // never embedded elsewhere.
        // Each is the only place where the customer resolution over cr.CustomerContract (main /
        // fallback / @Input override / none) and the emission ORDER of the assignment panel can be
        // observed rather than assumed.
        CiContractPersonsTestPage,
        CiContractInsurableObjectsTestPage,
        CiContractPaymentAccountsTestPage,
        CiContractAgentsTestPage,
        // (no ticket — ci agent/billing check 2026-10-08) — routed test bench of
        // <ci-collection-agent-billing-check>, declared only, never embedded elsewhere.
        CiCollectionAgentBillingCheckTestPage,

        // The price list's test page - routed under BOTH `ci/test/contractPrices` and
        // `cm/test/prices`, declared only, never embedded elsewhere. It is the only one of the family
        // that MEASURES the contract's own periods and holds them against the list: „genau ein Preis
        // pro Tag" is enforced nowhere in cm.ContractPrice, so the panel reports and never asserts.
        CiContractPricesTestPage,

        // [TM-1000001988 overnight A] — <ci-delivered-person-takeover> and
        // <ci-delivered-object-takeover>, the two „Feld · Lieferung · Bestand · Übernehmen" panels.
        //
        // DECLARED **and** EXPORTED, unlike the arm bodies above, and for the same reason
        // <ci-post-check-manual> is exported: they carry NO host context. Each one takes an anchor
        // (the customer / the object), the id of a row a HUMAN already picked and one delivered row,
        // and reports a decision. They advance no status, they know no pipeline arm and they resolve
        // no contract, so a screen outside this module that holds a delivery could legitimately
        // render either of them.
        //
        // ⚠ THEY ARE OUTSIDE Marko's components ON PURPOSE, not by convenience — 00:47:26: „you build
        // an additional component which shows the differences … this does not belong in here because
        // this is a single processing. This is a multi-processing." <ci-contract-persons> /
        // <ci-contract-insurable-objects> stay untouched; they SELECT, these two COMPARE.
        CiDeliveredPersonTakeoverComponent,
        CiDeliveredObjectTakeoverComponent,

        // The fourth test page, and the only one of them that has to prove WRITES. It measures the
        // anchor's cm.Contract.formerContract and its cm.ContractFormer rows through its OWN QL
        // batch before and after every write, rather than asking the component what it just did.
        CiContractFormersTestPage,

        // <ci-contract-type-tree> — the ci-owned Kategorie -> Sparte -> Vertragstyp tree, the LEFT
        // pane of the developer test page built on top of it. It emits the picked Vertragstyp and
        // nothing else.
        //
        // DECLARED ONLY, deliberately NOT exported: it is a selection navigator for ci's own test
        // page, not a panel another module could legitimately render. Its data comes from QL aliases
        // ('cm.Category' / 'cm.Group' / 'cm.ContractType'), which are plain strings — it adds NO
        // module edge ci -> cm, and its template renders no <cm-...> element.
        //
        // Needs no new module import: p-tree, p-skeleton, p-message and p-button all come from
        // SharedModule via the CoreModule edge already in imports below.
        CiContractTypeTreeComponent,

        // <ci-contract-type-insurable-objects> and <ci-contract-type-persons> — the two REUSABLE
        // pickers that narrow a customer's objects / persons by what ONE cm.ContractType permits and
        // demands. They resolve GET /mvsa/ci/contractTypeConfig themselves and wrap
        // <ci-customer-insurable-objects> (declared here) resp. <cr-customer-persons> (declared and
        // exported by CrModule, reached through the CrModule edge already in imports below).
        //
        // ⚠ THERE IS NO contractId ON EITHER. They run BEFORE a contract exists and report a DRAFT
        // (CiContractTypeDraftEntry, logic/ci-contract-type-draft.ts) with a client-generated key.
        // Neither writes a ci.ContractInsurableObject or ci.ContractPerson row — there is no contract
        // to hang one on; the only writes are the customer-side creations the embedded pickers
        // already perform under [allowCreate].
        //
        // EXPORTED since the cw step „Personen & Objekte" (projects/cw-ct30-persons-objects-step)
        // embeds both — the strand OUTSIDE ci this entry used to wait for. See the exports entry.
        //
        // Needs no new module import: p-message, p-tag, p-skeleton and p-button all arrive through
        // CoreModule / the TagModule + SkeletonModule entries below. No crudSuperComponent is
        // registered for either — neither renders <mvs-crud-object> as its own body.
        CiContractTypeInsurableObjectsComponent,
        CiContractTypePersonsComponent,

        // <ci-contract-type-config-test-page> — the routed developer test page of the ci Vertragstyp
        // configuration, mounted at `ci/test/contractTypeConfig`. It hosts <ci-contract-type-tree> on
        // the left and, on the right, the raw answer of GET /mvsa/ci/contractTypeConfig above the two
        // contract-type pickers declared directly above. The page is a DRIVER: it holds the two
        // anchors and logs every emission — the narrowing itself lives in the components, not here.
        //
        // DECLARED ONLY, never exported: the router is its only entry, exactly like the five sibling
        // test pages above it.
        //
        // ⚠ NO crudSuperComponent is registered for ci.ContractTypeInsurableObjectType,
        // ci.ContractTypeContractPersonType or either of their ReqField children, and none may be —
        // the reason is spelled out verbatim on the three contract sub-object lists further up. This
        // page WRITES NO CONFIGURATION anyway; it reads what is configured and shows what it produces.
        //
        // Needs no new module import: p-panel, p-inputNumber, p-button, p-divider, p-message, p-tag and
        // p-skeleton all arrive through CoreModule / the TagModule + SkeletonModule entries below.
        CiContractTypeConfigTestPage,

        // <mvs-ci-contract-type-insurable-objects-test-page> and
        // <mvs-ci-contract-type-persons-test-page> — one developer test page per contract-type picker,
        // mounted at `ci/test/contractTypeInsurableObjects` and `ci/test/contractTypePersons` (plus
        // their `cm/test/...` aliases; see ci.route.ts).
        //
        // ⚠ THEY ARE NOT A SECOND CiContractTypeConfigTestPage. That page DIAGNOSES the configuration
        // — Flag-Tabellen, Vererbungskette, Rohantwort, Vertragstyp-Baum — and stays the route for
        // that. These two DRIVE one component each: Steuerpanel, die Komponente groß und zentral, ein
        // nummeriertes Ereignisprotokoll darunter. The single configuration line they do render comes
        // from the component's own `onConfigResolved`, so neither page ever describes an answer nobody
        // acted on.
        //
        // DECLARED ONLY, never exported: the router is their only entry, exactly like every sibling
        // test page above.
        //
        // Needs no new module import: p-panel, p-inputNumber, pInputText, p-datePicker, p-toggleSwitch,
        // p-selectButton, p-button, p-message and p-tag all arrive through CoreModule / the TagModule
        // entry below — the same set CiContractTypeConfigTestPage and the five contract sub-object test
        // pages already bind.
        CiContractTypeInsurableObjectsTestPage,
        CiContractTypePersonsTestPage,

        // TM-1000002050: <ci-contract-policyholder-change-host> — the SLOT HOST of the cm wizard „VN-Wechsel“
        // (design projects/vn_wechsel/02-wizard-design.md §1.3, §1.5). It renders <cm-policyholder-change-wizard>
        // (CmModule, imported below) and fills its three slots with <cr-customer-persons>, <cr-object-billing-accounts>
        // (CrModule) and <ci-customer-create-wizard> (declared here) — the one module that may render all three.
        CiContractPolicyholderChangeHostComponent,
    ],
    exports: [
        CiBasicConfigPage,
        CiSearchFlexibleInsuranceComponent,
        CiContractInsurableObjectComponent,
        CiContractPersonComponent,
        CiInsurableObjectObjectComponent,
        CiCustomerInsurableObjectsComponent,
        CiCustomerInsurableObjectCreateComponent,
        // <ci-customer-external-objects> - the reconciliation wrapper. Exported because the screen
        // that HOLDS a delivery (a document or GDV import strand) lives outside this module and has
        // to be able to render it. Its card stays declaration-only, see the declarations entry.
        CiCustomerExternalObjectsComponent,
        // <ci-contract-former-contracts> - the Vorvertrags-Abgleich wrapper. Exported for the same
        // reason as <ci-customer-external-objects> above: the screen that holds a Vorvertrags-
        // Lieferung for one Ankervertrag lives outside this module. Its two children stay
        // declaration-only, see the declarations entry.
        CiContractFormerContractsComponent,
        // THE WIZARD IN ITS TWO PRESENTATIONS, both exported because a host outside this module may
        // legitimately want either.
        //
        // <ci-customer-create-wizard> renders the run INLINE, straight into the host's layout, and
        // starts it when it is created - which is what a screen whose whole purpose is the run needs
        // (see CrCustomerCreatePage). It has no [visible] input because it has no dialog to show.
        //
        // <ci-customer-create-wizard-dialog> is the same run AS A MODAL: it owns the p-dialog, the
        // „X" and an optional trigger button. It has no [visible] input either - a host opens it
        // through a @ViewChild and openWizard(), because every host that does so must first LOAD the
        // spec, and a two-way bound boolean would offer a second, unsynchronised way in.
        CiCustomerCreateWizardComponent,
        CiCustomerCreateWizardDialogComponent,
        // Generic, domain free and destined for core/shared - exported so any screen that has just
        // written or just picked a row can render <mvs-object-detail-expand> today.
        MvsObjectDetailExpandComponent,
        // [TM-1000001988 overnight B] — <ci-post-check-manual>, the rebuilt arm-5 body. Exported so
        // the host arm and the developer test page reach it by the same element name, and so a future
        // host outside this module can mount it: it takes everything it needs as @Inputs (contractId,
        // syncStatusId, findings) and emits every act, so it carries no hidden host context.
        CiPostCheckManualComponent,
        // [TM-1000001988, Haris 5 Sept 22:08] — the shared findings stack; see the declarations
        // entry. Exported so a host outside this module can render the same list.
        CiSyncFindingStackComponent,
        // [TM-1000001988 overnight A] — the two take-over panels. Exported so the arm-5 body can
        // mount them UNDER Marko's two lists by element name, and so any other screen holding a
        // delivery can. See the declarations entry for why they carry no host context.
        CiDeliveredPersonTakeoverComponent,
        CiDeliveredObjectTakeoverComponent,
        // [TM-1000001988 overnight C] — <ci-case-alignment-failure>, the rebuilt arm-3 body. Exported
        // for the same reason its arm-5 sibling above is: the host arm and the developer test page
        // reach it by the same element name, and it takes everything it needs as @Inputs and emits
        // every act, so it carries no hidden host context.
        CiCaseAlignmentFailureComponent,
        // (kein Ticket — ci header decision gate) — exported with its only mounting component.
        CiAlignmentDecisionMatrixComponent,
        // (kein Ticket — batch 2) — exported with the bodies that mount them.
        CiFormerContractEndListComponent,
        CiFormerContractAdvanceGuardComponent,
        // TM-1000002016: exported with its only mounting component.
        CiFormerContractDateChoiceComponent,
        // [TM-1000001988 overnight H] — <ci-relations-manual>, the arm-5 body after the pipeline
        // split, and <ci-delivered-cards>, the read-only „Lieferung (GDV)" print it stands on.
        // Exported for the same reason the two bodies above are: the host arm and the developer test
        // page reach them by element name, and both take everything they need as @Inputs.
        CiRelationsManualComponent,
        CiDeliveredCardsComponent,
        // [TM-1000001988 overnight 47] — exported for the same reason: the arm-3 body reaches it by
        // element name and it takes everything it renders as @Inputs.
        CiDeliveredMatchPairsComponent,
        // The two contract-type pickers — exported because the cw step „Personen & Objekte" mounts
        // them by element name, with [selectedPersonIds] / [selectedInsurableObjectIds] and
        // [showDiagnostics]="false". Both take everything they need as @Inputs and write nothing.
        CiContractTypeInsurableObjectsComponent,
        CiContractTypePersonsComponent,
        // TM-1000002050: exported because its opening host lives outside this module — the cm quick actions mount it
        // per opening by class (`createComponent`) and talk to it only through `contractId`, the four outputs and
        // `requestClose()`; it carries no hidden host context.
        CiContractPolicyholderChangeHostComponent,
    ],
    imports: [
        CoreModule,
        // The person-search step of CiCustomerCreateWizardComponent renders
        // <pm-person-search-component>, the one element CoreModule does not carry. PmModule itself
        // imports only CoreModule, ProgressSpinnerModule and UiModule and references nothing in ci,
        // so this edge adds no cycle.
        PmModule,
        // The four SET steps of CiCustomerCreateWizardComponent render <cr-object-addresses>,
        // <cr-object-contacts> and <mvs-cr-person-matrix>, which CrModule declares and exports.
        // CYCLE CHECK, done rather than assumed: CrModule.imports is CoreModule, UmModule, PmModule,
        // DmModule, WfModule, TmModule, PcModule, EuModule, NsModule, CmModule, UiModule, BmModule
        // and ChModule, and neither it nor anything reachable from it imports CiModule (repo wide,
        // CiModule is imported only by feature-crm.module, cw.module and the shell-test module). The
        // file level edge cr.entity-provider -> a ci COMPONENT that already exists does not close a
        // cycle either, because that component file does not import ci.module.
        CrModule,
        // TM-1000002050: the edge is BACK — see the end of this block (the history below stays as written).
        // ⚠ [TM-1000001988 overnight E] — THERE IS NO CmModule EDGE ANY MORE, and the removal was
        // MEASURED, not assumed. The edge existed for exactly one element,
        // <cm-create-insurable-object-others>, rendered by the INSURABLE_OBJECTS Fix drawer of
        // <ci-person-object-manual> (and before it by <ci-case-alignment-manual>). Both bodies are
        // deleted with the Buchungsmatrix, and the repo-wide grep their own comment asked the deleter
        // to re-run —
        //     grep -rn --include='*.html' "<cm-" features/feature-crm/ci
        // — now comes back EMPTY, as does the same grep over cr/page/object/cr-customer-create (the
        // one page declared here that lives outside ci).
        //
        // ⚠ It is safe to add back if a cm element is ever rendered here: the cycle check was done
        // rather than assumed (2026-09-04, cm.module.ts:487-499) — CmModule.imports is CoreModule,
        // DmModule, NsModule, NgOptimizedImage, TmModule and AutoFocusModule, none of which reaches
        // CiModule. ⚠ CwModule imports CiModule, so CiModule may NEVER import CwModule.
        //
        // TM-1000002050: A cm ELEMENT IS RENDERED HERE AGAIN, so the edge is back:
        // <ci-contract-policyholder-change-host> renders <cm-policyholder-change-wizard>, which CmModule
        // declares and exports. Cycle-free, checked (design §9.2: „zyklusfrei geprüft: CmModule importiert
        // weder CiModule noch CrModule“) —
        //     grep -nE "CiModule|CrModule" features/feature-crm/cm/cm.module.ts
        // is EMPTY, CmModule.imports is still CoreModule, DmModule, NsModule, NgOptimizedImage, TmModule
        // and AutoFocusModule, and the transitive NgModule closure of CmModule (20 app modules, measured
        // 2026-10-21 over every `imports: [...]` under features/) reaches neither CiModule, CrModule nor
        // CwModule. CrModule already imports CmModule, but NgModule declarations are not transitive, so
        // the element needs this direct edge.
        CmModule,
        // NO BmModule EDGE, although <ci-contract-payment-accounts> is a bm-facing list (its rows are
        // bm.ContractPaymentAccount and its assignment panel works on bm.CustomerBillingAccount). The
        // design drafted one and it was MEASURED AWAY, twice over:
        //
        //  - DECLARATIONS: the three new templates and their three test pages render no bm- selector
        //    at all. The payment-account list embeds <cr-object-billing-accounts>, which CrModule
        //    declares and exports and which is reached through the CrModule edge right above, plus
        //    <mvs-crud-object> from CoreModule. An NgModule import buys declarations, and there is no
        //    bm declaration to buy.
        //  - PROVIDERS: BM_ENTITY_PROVIDER is declared in bm.module.ts:871, and CrModule imports
        //    BmModule (cr.module.ts:764). Angular providers ARE transitive through the import graph -
        //    only declarations are not - so the bm.ContractPaymentAccount registration already reaches
        //    ci over CiModule -> CrModule -> BmModule without a direct edge.
        //
        // Should a bm ELEMENT ever be rendered here, the edge becomes real and is safe to add: the
        // cycle check was done rather than assumed - bm.module.ts imports CommonModule, CoreModule,
        // UiModule, DmModule, BdModule and FeatureBmRoutingModule plus PrimeNG, neither CrModule nor
        // CiModule nor CmModule, so BmModule is a sink.
        // TM-1000001985 — the „Suche" box of ci-convert-customer-detail-panel is a plain pInputText
        // wrapped in an icon field (see that template for why it is NOT a p-autoComplete any more).
        // SharedModule IMPORTS these two standalone components for its own templates but does not
        // re-export them, so the feature module declares its own need rather than widening a shared
        // surface for one screen — fe_core_primeng, „Feature modules may import additional PrimeNG
        // modules only if required".
        IconField,
        InputIcon,
        // The Vorgang list of <ci-customer-case-selection> is a RADIO group — one line, single select.
        // SharedModule imports RadioButtonModule for its own templates but does NOT re-export it, so
        // the feature module declares its own need rather than widening a shared surface for one
        // screen — same rule and same reason as IconField/InputIcon above.
        RadioButtonModule,
        // TM-1000001988 — the state chips of the manual review arms and of the developer test pages
        // („zugeordnet" / „offen" / „gebucht") are p-tag. SharedModule imports TagModule for its own
        // templates but does NOT re-export it, so the feature module declares its own need rather than
        // widening a shared surface — the same rule and the same reason as IconField/InputIcon and
        // RadioButtonModule above (fe_core_primeng, „Feature modules may import additional PrimeNG
        // modules only if required").
        TagModule,
        // TM-1000001988 — p-skeleton is the loading arm of the delivered-row cards and of every
        // developer test page in this module. Same rule as TagModule above: SharedModule imports it
        // for its own templates but does not re-export it.
        //
        // ⚠ [TM-1000001988 overnight E] — ProgressBarModule stood beside it for <ci-takeover-ledger>'s
        // „X von Y Bereichen übernommen" bar. That component is deleted and
        //     grep -rn --include='*.html' "p-progressBar" features/feature-crm/ci
        // is empty, so the import is gone with it.
        SkeletonModule
    ],
    providers: [CI_ENTITY_PROVIDER, CI_TEST_PROVIDERS]
})
export class CiModule {
}